<template>
  <section :class="mainCls">
    <!-- <el-scrollbar style="height:100%;overflow-x:hidden;"></el-scrollbar> -->
    <transition name="fade" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view></router-view>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    // 用于解决roadOperation页面main样式冲突问题
    mainCls() {
      return this.$route.name === 'roadOperation' ? 'main road-operation-main' : 'main'
    },
  },
}
</script>

<style lang="stylus" scoped>
.main, .road-operation-main {
  height: 'calc(%s - %s)' % (100% 10px);
  padding: 15px;
  overflow: auto;
  box-sizing: border-box;
}
</style>
